module.exports = __webpack_public_path__ + "img/symbol_1.a6817ab4.png";